<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px " placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="applyStatus">
                        <el-select v-model="applyStatus" clearable placeholder="请选择" @change="getDataList">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询
                        </el-button>
                        <!-- <el-button type="primary" size="small" @click="methodFrozen()" style="margin-left:20px">冻结</el-button>
                        <el-button type="primary" size="small" @click="methodThaw()" style="margin-left:20px">解冻</el-button> -->
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  border :header-cell-style="{background:'#f5f5f5'}">
            <!-- <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column> -->
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="applyformType" header-align="center" align="left" label="审批类型" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.applyformType }}
                </template>
            </el-table-column> -->
            <el-table-column prop="applyformNum" header-align="center" align="right" width="120" label="审批单号">
                    <template slot-scope="scope">
                        {{ scope.row.applyformNum }}
                    </template>
                </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <!-- <el-button type="text" @click="venderUserDetail(scope.row)"> {{ scope.row.venderName }}</el-button> -->
                    <el-button type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>

            <el-table-column prop="applyStatus" header-align="center" align="center" width="120" label="状态">
                    <template slot-scope="scope">
                        <span style="color:#67C23A" v-for="(item, index) in scope.row.applyStatus.split(',')" :key="index" size="mini" type="success">{{item}}<br></span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="pic"
                        header-align="center"
                        align="center"
                        width="120"
                        label="当前流程图示">
                    <template slot-scope="scope">
                        <el-link :disabled="scope.row.applyStatus === '流程结束'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="pic"
                        header-align="center"
                        align="center"
                        width="120"
                        label="评审附件">
                    <template slot-scope="scope">
                        <el-link type="primary" style="font-size: 12px;" @click="viewThawFile(scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>

                <el-table-column prop="createdName" header-align="center" align="left" width="120" label="申请人">
                    <template slot-scope="scope">
                        {{ scope.row.createdName }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" header-align="center" align="left" width="200" label="申请原因">
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTimeStr" header-align="center" align="right" width="200" label="申请日期" >
                    <template slot-scope="scope">
                        {{ scope.row.createTimeStr }}
                    </template>
                </el-table-column>

            <el-table-column prop="disReason" header-align="center" align="center" label="审批历史">
                    <template slot-scope="scope">
                        <el-button @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="170px">
                  <template slot-scope="scope">
                      <div v-for="(item,index) in scope.row.taskActions" :key="index">
                        <el-button v-if="item.flowRuleType===null" type="text" size="small" @click="adoptHandle(scope.row.id, item.taskId, item.flowRuleType, item.normalValue)" icon="el-icon-circle-check">重新提交</el-button>
                        <el-button v-if="item.flowRuleType!=null" type="text" size="small" @click="adoptHandle(scope.row.id, item.taskId, item.flowRuleType, item.normalValue)" icon="el-icon-circle-check">通过</el-button>
                        <el-button v-if="item.flowRuleType!=null" type="text" size="small" @click="rejectHandle(scope.row.id, item.taskId, item.flowRuleType, item.reverseValue)" icon="el-icon-circle-close" style="color:#F56C6C">驳回</el-button>
                      </div>
                  </template>
                </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>

        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 文件列表 -->
        <freezing-file v-if="thawFileVisible" ref="freezingFile"></freezing-file>

        <el-dialog
                :visible.sync="showViewer"
                width="80%"
                title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog>

        <el-dialog title="审批" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="dataRule">
            <el-form-item label="驳回原因:" :label-width="formLabelWidth" prop="remarks">
                <el-input type="textarea" v-model="form.remarks" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
            <el-button type="primary" @click="rejectHandle2" size="mini">确 定</el-button>
        </div>
        </el-dialog>

        <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
                   style="min-height:100px" @close="closegps" :close-on-click-modal="false">
            <div style="min-hight:100px">
                <div style="margin-top:5px">                        
                    <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane name="企业概况" :key="'first'">
                            <span slot="label"><span style="color: red">*</span> 企业概况</span>
                            <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
                        </el-tab-pane>
                        <el-tab-pane name="主要联系人员" :key="'second'">
                            <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
                            <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
                        </el-tab-pane>
                        <el-tab-pane label="企业资源情况" name="企业资源情况">
                            <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
                            <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
                        </el-tab-pane>
                        <el-tab-pane  label="工厂及地址" name="工厂及地址">
                            <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
                            <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
                        </el-tab-pane>
                        <el-tab-pane  label="企业经营状况" name="企业经营状况">
                            <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
                            <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
                        </el-tab-pane>
                        <el-tab-pane  label="主要产品目录" name="主要产品目录">
                            <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
                            <product-info ref="productInfo" :superId="this.supplierId"></product-info>
                        </el-tab-pane>
                        <el-tab-pane  label="附件上传" name="附件上传">
                            <span slot="label"><span style="color: red">*</span> 附件上传</span>
                            <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </el-dialog>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                        <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                        <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                </el-descriptions>
              <el-divider></el-divider>
            </div>
        </el-drawer>

        <el-dialog
          title="提示"
          :visible.sync="fileDialogVisible"
          width="60%"
          :modal="false"
          >

          <!-- 上传下载 查看 需求文档 -->
            <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>

    </div>
</template>
<script>
    import {executeApprove,selectApplyFormPage} from '@/controller/supplier'
    import AddOrUpdate from './supplier-info-add-or-update'
    import FreezingFile from './freezing-file'
    import { listAllStatus,getProcessDiagramCurrent,listCommentHistory} from '@/controller/workflow'
    import FileUpDown from "@/views/common/file-up-down"

    import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
    import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
    import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
    import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
    import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
    import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
    import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'

    export default {
        data() {
            return {
                FILE_BIZ_TYPE:9,
                FILE_SUB_TYPE:0,
                dataForm: {
                    id:'',
                    key: ''
                },
                applyStatus: '',
                showViewer: false,
                fileDialogVisible:false,
                diagramUrl: '',
                activeName: '',
                gpsdialog: false,
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                dialogFormVisible: false,
                formLabelWidth: '120px',
                supplierId:'',
          
                venderName: '',
            
              
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                
                dataRule: {
                    remarks: [
                        { required: true, message: '请填写驳回原因', trigger: 'blur' }
                    ],
                },

                addOrUpdateVisible: false,
                frozenThawVisible: false,
                thawFileVisible:false,

                venderCode : '',

                // 通过或驳回表单
                form: {
                        remarks: '',
                        id: '',
                        taskId:'', 
                        flowType:'', 
                        val:''
                    },

                // 审批历史
                drawer: false,
                // 审批列表
                historyList:[],
            }
        },

        components: {
            AddOrUpdate,FreezingFile,FileUpDown,
            EnterpriseProfile,
            ResourceInfo,
            MainContacts,
            FactoryInfo,
            BusinessInfo,
            ProductInfo,
            AttachmentUpload
        },

        activated() {
            if (this.$route.query && this.$route.query.state && this.$route.query.state.length > 0) {
                this.applyStatus = this.$route.query.state
            }
            this.getDataList()
            this.getAllStatus()
        },

        methods: {

            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },

            viewDiagram(id) {
                getProcessDiagramCurrent({id: id}).then(data => {
                    this.diagramUrl = data.body
                    this.showViewer = true
                })
            },

            // 显示文件列表
            viewThawFile(row){
                // this.thawFileVisible = true
                // this.$nextTick(() => {
                //     this.$refs.freezingFile.init(row)
                // })
                if(row.applyformType === '3'){
                    this.FILE_SUB_TYPE = 3
                }
                if(row.applyformType === '4'){
                    this.FILE_SUB_TYPE = 4
                }
                this.dataForm.id = row.targetId
                this.fileView()
            },

            getAllStatus(){
                listAllStatus({
                    'processDefKey': 'SUPPLIER_FREEZE2025'
                }).then(data => {
                    if (data && data.code === '00') {
                        this.options1 = data.body.map(str => {
                            return {'value': str, 'label': str}
                        })
                    }
                })
            },

            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectApplyFormPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName,
                    'applyStatus': this.applyStatus,
                    'applyformType' : '3',
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.starttime = data.starttime
                        this.endtime = data.endtime
                        this.interfacestarttime = data.endtime
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },
            
            
            // 驳回
            rejectHandle(id, taskId, flowType, val) {
                this.form.remarks = ''
                this.form.id = id,
                this.form.taskId = taskId,
                this.form.flowType = flowType,
                this.form.val = val,

                this.dialogFormVisible = true
            },

            // 驳回2
            rejectHandle2() {
                if(!this.form.remarks){
                    this.$message({message: '请填写驳回原因',type: 'error'})
                    return
                }

                this.$confirm(`确定进行通过操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.dialogFormVisible = false
                        let params = {
                          'id': this.form.id,
                          'unQuoteReason': this.form.remarks,
                          'taskId': this.form.taskId,
                          'paramKey': this.form.flowType,
                          'paramVal': this.form.val,
                        }

                        executeApprove(params
                        ).then(data => {
                            if (data && data.code === '00') {
                                this.getDataList()
                                this.$message({
                                    message: '审批成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                              this.$message.error(data.msg)
                            }
                        })
                    })
            },

            // 通过
            adoptHandle(id, taskId, flowType, val) {
                this.$confirm(`确定进行通过操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let params = {
                          'id': id,
                          'taskId': taskId,
                          'paramKey': flowType,
                          'paramVal': val
                        }

                executeApprove(params
                        ).then(data => {
                            if (data && data.code === '00') {
                                this.getDataList()
                            this.$message({
                                message: '审批成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.visible = false
                                    this.$emit('refreshDataList')
                                    this.dialogFormVisible = false
                                }
                            })
                            } else {
                            this.$message.error(data.msg)
                            }
                        })
                    })
            },

            //已完成未完成筛选
            handleCheckAllChange() {
                this.pageIndex = 1
                this.getDataList()
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
            //查看
            venderUserDetail(row) {
                row.isE = 0;
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row)
                })
            },
            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            

            // 冻结接口
            methodFrozen(row){
                row.isE = 0;
                this.frozenThawVisible = true
                this.$nextTick(() => {
                    this.$refs.frozenThaw.init(row)
                })
            },

            // 解冻接口
            methodThaw(row){
                row.isE = 1;
                this.frozenThawVisible = true
                this.$nextTick(() => {
                    this.$refs.frozenThaw.init(row)
                })
            },

            handleClick: function () {
                if (this.activeName === '企业概况') {
                    this.$refs.enterpriseProfile.getDataList(this.superId)
                }
                if (this.activeName === '主要联系人员') {
                    this.$refs.mainContacts.getDataList(this.superId)
                }
                if (this.activeName === '企业资源情况') {
                    this.$refs.resourceInfo.getDataList(this.superId)
                }
                if (this.activeName === '工厂及地址') {
                    this.$refs.factoryInfo.getDataList(this.superId)
                }
                if (this.activeName === '企业经营状况') {
                    this.$refs.businessInfo.getDataList(this.superId)
                }
                if (this.activeName === '体系认证情况') {
                    this.$refs.certificationInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要产品目录') {
                    this.$refs.productInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要设备清单') {
                    this.$refs.equipmentList.getDataList(this.superId)
                }
                if (this.activeName === '附件上传') {
                    this.$refs.attachmentUpload.getDataList(this.superId)
                }
            },

            handleUpdate(row) {
                this.gisIdKey = row.targetId
                this.gpsPid = row.pid
                this.activeName = '企业概况'
                this.gpsdialog = true
                this.targetId = row.targetId
                this.applyformId = row.applyformId
                this.statusbotton = row.applyStatus
                this.nextapplyformId = row.nextapplyformId
                this.approveLevel = row.approveLevel
                this.updatedBy = row.updatedBy
                this.supplierId = row.venderInviteFid
                this.superId = row.venderInviteFid
                this.$nextTick(() => {
                    this.$refs.enterpriseProfile.getDataList(row.venderInviteFid)
                })
            },

            closegps() {
                this.getDataList()
            },

            // 审批历史
            doHistory(row){
                this.historyList = []
                listCommentHistory({'workflowId' : row.workflowId}).then(data => {
                    if (data && data.code === '00') {
                        this.historyList = data.body
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                this.drawer = true
            },

        // 文件列表
        fileView(){
            this.fileDialogVisible = true
            this.$nextTick(()=>{
                this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, this.FILE_SUB_TYPE)
            })
        },
            
        }
    }
</script>